import { render, staticRenderFns } from "./KeywordGenreTable.vue?vue&type=template&id=699f9495"
import script from "./KeywordGenreTable.vue?vue&type=script&lang=js"
export * from "./KeywordGenreTable.vue?vue&type=script&lang=js"
import style0 from "./KeywordGenreTable.vue?vue&type=style&index=0&id=699f9495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports